module.exports = __webpack_public_path__ + "static/media/remboursement-anticipe.2dc57050.svg";